module.exports = __webpack_public_path__ + "87aaa859c614bd2c14db431d31f5095e.jpg";